// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root,
.app,
.content {
    block-size: 100%;
    inline-size: 100%;
    font-style: normal;
    font-stretch: normal;
    font-family: 'Poppins', sans-serif;
}
.homepagecolores {
    inline-size: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    block-size: 91%;
    /* background: linear-gradient(135deg, #f5f8fd, #f2f6fc); */
    background-color: rgb(240, 246, 255); /* Lightest shade from your palette */
}
.app {
    display: flex;
    position: relative;
}

::-webkit-scrollbar {
    inline-size: 6px;
    border-radius: 40px;
}

/* Track */

::-webkit-scrollbar-track {
    background: #e0e0e0;
    border-radius: 40px;
}


/* Handle */

::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 40px;
}


/* Handle on hover */

::-webkit-scrollbar-thumb:hover {
    background: #555;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;;;;;IAKI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,2DAA2D;IAC3D,oCAAoC,EAAE,qCAAqC;AAC/E;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,UAAU;;AAEV;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA,WAAW;;AAEX;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA,oBAAoB;;AAEpB;IACI,gBAAgB;AACpB","sourcesContent":["html,\nbody,\n#root,\n.app,\n.content {\n    block-size: 100%;\n    inline-size: 100%;\n    font-style: normal;\n    font-stretch: normal;\n    font-family: 'Poppins', sans-serif;\n}\n.homepagecolores {\n    inline-size: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    block-size: 91%;\n    /* background: linear-gradient(135deg, #f5f8fd, #f2f6fc); */\n    background-color: rgb(240, 246, 255); /* Lightest shade from your palette */\n}\n.app {\n    display: flex;\n    position: relative;\n}\n\n::-webkit-scrollbar {\n    inline-size: 6px;\n    border-radius: 40px;\n}\n\n/* Track */\n\n::-webkit-scrollbar-track {\n    background: #e0e0e0;\n    border-radius: 40px;\n}\n\n\n/* Handle */\n\n::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 40px;\n}\n\n\n/* Handle on hover */\n\n::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
